import { fetchToken } from "../../common/FetchCookie";
import { ADMIN, BASE_URL, SKILL_DEVELOPMENT } from "../../common/URLs";

// Helper: throw on non-OK or { status: false }
const parseJsonOrThrow = async (res) => {
    // Parse safely in case of empty responses or non-JSON
    const text = await res.text();
    let json = {};
    try {
        json = text ? JSON.parse(text) : {};
    } catch {
        json = {};
    }

    if (!res.ok || json?.status === false) {
        const message = json?.message || json?.error || `Request failed (${res.status})`;
        const err = new Error(message);
        err.response = json;
        err.status = res.status;
        throw err;
    }
    return json;
};

export const fetchSkillDevelopmentAdmin = async () => {
    const token = await fetchToken();
    const res = await fetch(`${BASE_URL}/${ADMIN}/${SKILL_DEVELOPMENT}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
    return parseJsonOrThrow(res); // { status, response: [...], code }
};

export const addSkillDevelopmentAdmin = async (newSkillDevelopment) => {
    const token = await fetchToken();
    const isFormData =
        typeof FormData !== "undefined" && newSkillDevelopment instanceof FormData;

    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    if (!isFormData) {
        headers["Content-type"] = "application/json";
    }

    const res = await fetch(`${BASE_URL}/${ADMIN}/${SKILL_DEVELOPMENT}`, {
        method: "POST",
        headers,
        body: isFormData ? newSkillDevelopment : JSON.stringify(newSkillDevelopment),
    });
    return parseJsonOrThrow(res); // { status, response: {...}, code }
};

// UPDATED: uuid required in URL, supports JSON or FormData.
// If FormData, use POST + _method=PUT (Laravel-friendly for file uploads)
export const updateSkillDevelopmentAdmin = async (uuid, updated) => {
    const token = await fetchToken();
    const isFormData = typeof FormData !== "undefined" && updated instanceof FormData;

    const headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let method = "PUT";
    let body = updated;

    if (isFormData) {
        // IMPORTANT for many backends (e.g., Laravel): multipart + PUT is problematic.
        // Use POST with _method override to "PUT".
        updated.append("_method", "PUT");
        method = "POST";
        // Do not set Content-Type when sending FormData
    } else {
        headers["Content-type"] = "application/json";
        body = JSON.stringify(updated);
    }

    const res = await fetch(`${BASE_URL}/${ADMIN}/${SKILL_DEVELOPMENT}/${uuid}`, {
        method,
        headers,
        body,
    });
    return parseJsonOrThrow(res); // { status, response: {...}, code }
};

export const deleteSkillDevelopmentAdmin = async (uuid) => {
    const token = await fetchToken();
    const res = await fetch(`${BASE_URL}/${ADMIN}/${SKILL_DEVELOPMENT}/${uuid}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
    return parseJsonOrThrow(res); // { status, response: null|{}, code }
};